import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useT } from "@/i18n";

export const UpgradeDialog = ({ open, onOpenChange, message }) => {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="upgrade-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-brand-700">
            <Sparkles className="h-6 w-6 text-white" />
          </div>
          <DialogTitle className="text-center font-display">{t("upgrade.title")}</DialogTitle>
          <DialogDescription className="text-center">{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="upgrade-later-btn">
            {t("upgrade.later")}
          </Button>
          <Button data-testid="upgrade-cta-btn" onClick={() => { onOpenChange(false); navigate("/pricing"); }}
            className="bg-brand-500 hover:bg-brand-600 text-black">
            {t("upgrade.cta")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
